<template>
  <footer>
    <div class="footer container">
      <div class="row">
        <div class="col-12 col-md-6 order-1 order-md-0">
          <div class="d-flex align-items-center justify-content-between justify-content-md-start header-logo-list">
            <div class="sublogo-container mb-0">
              <p v-if="companies.title">{{ companies.title }}</p>
              <p v-else>See all company brands:</p>
              <img
                :src="[companies.sublogoImg.imgLink || altLogo]"
                :alt="[companies.sublogoImg.altText || 'sublogo-image']"
                class="d-block"
                :class="{'mt-1': !companies.sublogoImg.imgLink}"
                width="120"
                height="30"
              />
            </div>
            <div class="d-flex d-md-none justify-content-end mawazo mt-0">
              <a href="https://www.mawazo.ca/" class="d-inline-block">
                <img :src="mawazo" alt="mawazo-image" width="80" height="15">
              </a>
            </div>
          </div>
          <ul class="d-flex footer-links">
            <li v-for="page in footer.pageLinks">
              <a :href="page.link" class="hover-text-black">{{ page.title }}</a>
            </li>
          </ul>
          <small class="lh-26">{{ footer.copyright }}</small>
        </div>
        <div class="col-12 col-md-6 order-0 order-md-1">
          <div class="d-md-flex justify-content-md-end pt-3">
            <div>
              <div class="d-flex justify-content-center justify-content-md-end social">
                <div class="d-flex">
                  <small class="lh-26">
                    {{ footer.socialMedia.title }}
                  </small>
                  <div class="d-grid social-icons">
                    <Link v-if="footer.socialMedia.metaLink.length" :href="footer.socialMedia.metaLink" class="social-icon-effect"><FbIcon /></Link>
                    <Link v-if="footer.socialMedia.twitterLink.length" :href="footer.socialMedia.twitterLink" class="social-icon-effect-extended"><TwitterIcon /></Link>
                    <Link v-if="footer.socialMedia.linkedInLink.length" :href="footer.socialMedia.linkedInLink" class="social-icon-effect-extended"><LinkedInIcon /></Link>
                    <Link v-if="footer.socialMedia.instagramLink.length" :href="footer.socialMedia.instagramLink" class="social-icon-effect-extended"><LinkedInIcon /></Link>
                    <Link v-if="footer.socialMedia.youTubeLink.length" :href="footer.socialMedia.youTubeLink" class="social-icon-effect-extended"><YoutubeIcon /></Link>
                  </div>
                </div>
              </div>
              <div class="accreditation mb-5 mb-md-0">
                <div class="accreditation-icons align-items-center">
                  <Link class="d-flex justify-content-center" :href="acc.siteLink" v-for="acc in footer.accreditationIcons.children">
                    <img :src="acc.imgLink" :alt="acc.alt" width="62" height="45">
                  </Link>
                  <Link :href="footer.accreditationIcons.mainLink" class="info-icon d-flex justify-content-center social-icon-effect">
                    <InfoIcon />
                  </Link>
                </div>
              </div>
              <div class="d-none d-md-flex justify-content-end mawazo">
                <Link href="https://utm.io/footer" class="d-inline-block">
                  <img :src="mawazo" alt="mawazo-image" width="80" height="15">
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterBorderLines />
  </footer>
</template>

<script>
import TriangleMini from "@/assets/icons/triangle-mini";
import FbIcon from "@/assets/icons/fb-icon";
import TwitterIcon from "@/assets/icons/Twitter-icon";
import YoutubeIcon from "@/assets/icons/Youtube-icon";
import InfoIcon from "@/assets/icons/Info-icon";
import Mawazo from '@/assets/images/mawazo-color.png'
import FooterBorderLines from "@/components/footer/FooterBorderLines";
import AltLogo from '@/assets/images/alt-logo.png';
import LinkedInIcon from "@/assets/icons/linkedIn-icon.vue";
import Link from "@/components/common/Link";

export default {
  components: {
    Link,
    FooterBorderLines,
    InfoIcon,
    YoutubeIcon,
    TwitterIcon,
    FbIcon,
    TriangleMini,
    LinkedInIcon
},
  data(){
    return {
      mawazo: Mawazo,
      altLogo: AltLogo
    }
  },
  props: {
    companies: {
      logo: {
        imgLink: String,
        altText: String
      },
      sublogoImg: {
        imgLink: String,
        altText: String
      },
      sublogoContent: {
        title: String,
        description: String,
        logos: Array
      }
    },
    footer: {
      pageLinks: Array,
      copyRight: String,
      socialMedia: {
        title: String,
        twitterLink: String,
        metaLink: String,
        linkedInLink: String,
        instagramLink: String,
        youTubeLink: String
      },
      accreditationIcons: {
        mainLink: 'string',
        children: Array
      }
    }
  }
}
</script>
